import type { CSSProperties } from 'react';

import type { PanelItemColor } from '../types';

export type NgBadgeProps = {
  color: PanelItemColor;
  value: string;
  label?: string;
};

const COLOR_CLASS: Record<PanelItemColor, string> = {
  none: 'text-secondary bg-secondary',
  excellent: 'text-success bg-success',
  warning: 'text-warning bg-warning',
  critical: 'text-danger bg-danger',
};

export function NgBadge({ color, value, label }: NgBadgeProps) {
  return (
    <div className="d-flex flex-row gap-1 text-nowrap">
      {label != null && <span className="text-muted">{label}:</span>}
      <span
        className={`px-1 rounded ${COLOR_CLASS[color]}`}
        style={{ '--bs-bg-opacity': 0.1 } as CSSProperties}
      >
        {' '}
        {value}
      </span>
    </div>
  );
}
